import umLogo from '@/assets/universities/um.png';
import umWalesLogo from '@/assets/universities/um-wales.png';
import msuLogo from '@/assets/universities/msu.png';
import nottinghamLogo from '@/assets/universities/nottingham.png';
import monashLogo from '@/assets/universities/monash.png';

const universities = [
  { name: 'Universiti Malaya', logo: umLogo, style: { height: 44 } },
  { name: 'University of Malaya-Wales', logo: umWalesLogo, style: { height: 38 } },
  { name: 'Management & Science University', logo: msuLogo, style: { height: 110 } },
  { name: 'University of Nottingham', logo: nottinghamLogo, style: { height: 120, marginRight: -6 } },
  { name: 'Monash University', logo: monashLogo, style: { height: 125, marginLeft: -6 } },
];

export function UniversityLogoStrip() {
  return (
    <section className="py-10 md:py-14 border-t border-b border-border/40 bg-muted/20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <p className="text-center text-xs md:text-sm font-medium tracking-[0.15em] uppercase text-muted-foreground mb-8 md:mb-10">
          Used by students and researchers from
        </p>

        <div className="flex items-center justify-center gap-8 md:gap-12 lg:gap-14 flex-wrap">
          {universities.map((uni) => (
            <img
              key={uni.name}
              src={uni.logo}
              alt={`${uni.name} logo`}
              style={{ height: uni.style.height }}
              className="w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
